import React, { Component } from "react"
import PropTypes from 'prop-types'
import MetaTags from 'react-meta-tags';
import { Link } from "react-router-dom"
import {Col, Container, Row} from "reactstrap"
import { connect } from "react-redux"

//i18n
import { withTranslation } from "react-i18next"
import axios from "axios"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import LoadUnlayer from "../Email/unlayer-draft";
import RsLink from "components/buttons/rsLink";
import { API_URL } from "helpers/app_url";
import { getProjectUUIDAction, getDraftTemplate } from "store/actions";
import { template } from "lodash";
import { on } from "solid-js";
import CopyText from "components/buttons/copyBtn";

class projectDraftMailEditor extends Component {
    constructor(props) {
        super(props);
        this.state = {
            templateName : '',
            design: {},
            id: '',           
            projectId: '',    
            templateId: ''  
        }
        this.handleChange = this.handleChange.bind(this);
        this.exportHtml = this.exportHtml.bind(this);
        this.LoadUnlayerRef = React.createRef();   
    }
    handleChange(event) {
        this.setState({ templateName: event.target.value });
      }
fetchEmailTemplate(id) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
    axios
      .get(`${API_URL}ProjectEmailCampaign/${id}`, { headers })
      .then((response) => {
        this.setState({ emailData: response.data, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
      componentDidMount() {
        const { match,  ongetProjectUUIDAction, onGetDraftTemplate } = this.props;
        const { id, projectId, templateId } = match.params;
        ongetProjectUUIDAction(projectId);
        this.fetchEmailTemplate(templateId)
        this.setState({
            id,
            projectId,
            templateId
        });
         this.autoSaveInterval = setInterval(() => {
          this.saveasdraft();
        }, 30000);
    }
     componentWillUnmount() {
      if (this.autoSaveInterval) {
        clearInterval(this.autoSaveInterval);
      }
  }
      exportHtml = () => {
   
        if (this.LoadUnlayerRef && this.LoadUnlayerRef.current) {
      
          this.LoadUnlayerRef.current.exportHtml((htmlContent) => {
            
           const payload = {
                        id: parseInt(this.props.templatedata.id),
                        projectEmailCampaignId: this.props.templatedata.projectEmailCampaignId,
                        emailCampaignProjectId: parseInt(this.props.templatedata.emailCampaignProjectId),
                        campaignProjectGuid: this.props.templatedata.campaignProjectGuid,
                        emailCampaignTemplateId: this.props.templatedata.emailCampaignTemplateId,
                        emailCampaignCss: this.props.templatedata.emailCampaignCss,
                        emailCampaignFullContent: JSON.stringify(htmlContent.design),
                        agentId: parseInt(localStorage.getItem("userId")),
                        isActive: true,
                        emailCampaignTitle: this.props.templatedata.emailTemplateTitle,
                        emailCampaignSubject: this.props.templatedata.emailCampaignSubject,
                        emailCampaignContent:  htmlContent.html,
                        emailCampaignListIds: this.props.templatedata.emailCampaignListIds,
                        emailTargetTypeId: parseInt(this.props.templatedata.emailTargetTypeId),
                        emailTargetSubTypeId: parseInt(this.props.templatedata.emailTargetSubTypeId),
                        emailTargetFilter: this.props.templatedata.emailTargetFilter,
                        emailCampaignSchedule: this.props.templatedata.emailCampaignSchedule,
                        emailCampaignSendStatus: this.props.templatedata.emailCampaignSendStatus,   
                        emailCampaignPublishStatus: this.props.templatedata.emailCampaignPublishStatus,
                    };
              const obj = JSON.parse(localStorage.getItem("authUser"));
              const token = obj.resultData.bearerToken;
              const str = 'Bearer ' + token;
              const headers = {
                  'Content-Type': 'application/json',
                  'Authorization': str
              }
              
              toast.loading("Please wait...");
              axios.put(`${API_URL}ProjectEmailCampaign/updateProjectEmailCampaignPartialinfo`, payload, {
                  headers: headers
                })
                .then((response) => {
                    toast.dismiss();
                  
                    this.props.history.push('/pre-construction/mail-send/' + response.data.projectEmailCampaign.id + '/' + response.data.projectEmailCampaign.projectEmailCampaignId);
                })
                .catch((error) => {
                 
                }) 
            });
           

        }
      };
    
      saveasdraft = () => {
        if (this.LoadUnlayerRef && this.LoadUnlayerRef.current) {
          this.LoadUnlayerRef.current.exportHtml((htmlContent) => {
           
           const payload = {
                id: parseInt(this.props.templatedata.id),
                projectEmailCampaignId: this.props.templatedata.projectEmailCampaignId,
                emailCampaignProjectId: parseInt(this.props.templatedata.emailCampaignProjectId),
                campaignProjectGuid: this.props.templatedata.campaignProjectGuid,
                emailCampaignTemplateId: this.props.templatedata.emailCampaignTemplateId,
                emailCampaignCss: this.props.templatedata.emailCampaignCss,
                emailCampaignFullContent: JSON.stringify(htmlContent.design),
                agentId: parseInt(localStorage.getItem("userId")),
                isActive: true,
                emailCampaignTitle: this.props.templatedata.emailTemplateTitle,
                emailCampaignSubject: this.props.templatedata.emailCampaignSubject,
                emailCampaignContent:  htmlContent.html,
                emailCampaignListIds: this.props.templatedata.emailCampaignListIds,
                emailTargetTypeId: parseInt(this.props.templatedata.emailTargetTypeId),
                emailTargetSubTypeId: parseInt(this.props.templatedata.emailTargetSubTypeId),
                emailTargetFilter: this.props.templatedata.emailTargetFilter,
                emailCampaignSchedule: this.props.templatedata.emailCampaignSchedule,
                emailCampaignSendStatus: this.props.templatedata.emailCampaignSendStatus,   
                emailCampaignPublishStatus: this.props.templatedata.emailCampaignPublishStatus,
                };
            // 
            const obj = JSON.parse(localStorage.getItem("authUser"));
            const token = obj.resultData.bearerToken;
            const str = 'Bearer ' + token;
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': str
            }
            //toast.loading("Please wait...");
            axios.put(`${API_URL}ProjectEmailCampaign/updateProjectEmailCampaignSaveDraft`, payload, {
                    headers: headers
                  })
                  .then((response) => {
                    //toast.dismiss();
                    //toast.success("Saved");
                    history.push('/pre-construction/my-project');
                    
                  })
                  .catch((error) => {
                   
                  }) 
          });
        }
      };

      sendPreview = () => {
       
         
          if (this.LoadUnlayerRef && this.LoadUnlayerRef.current) {
            this.LoadUnlayerRef.current.exportHtml((htmlContent) => {
              //console.log(htmlContent)
              const html = htmlContent.html;
              const cleanedHtml = html.replace(/\n/g, "");
            const payload = {
              'agentId': parseInt(localStorage.getItem("userId")),
              'emailCampaignFullContent':  JSON.stringify(cleanedHtml),
              'emailCampaignProjectId': parseInt(this.props.projectData.id),
              'emailCampaignTemplateId': parseInt(this.state.templateId),
              'emailCampaignTitle' : 'Preview Email',
              'emailCampaignSubject' : 'Preview Email',
              'emailCampaignContent' : cleanedHtml,
              'emailCampaignCss' : '',
              //'emailCampaignPublishStatus' : 'draft',
              'IsActive':true
            };
            const obj = JSON.parse(localStorage.getItem("authUser"));
            const token = obj.resultData.bearerToken;
            const str = 'Bearer ' + token;
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': str
            }
            toast.loading("Please wait...");
            axios.post(`${API_URL}ProjectEmailCampaign/previewprojectemailcampaign`, payload, {
                    headers: headers
                  })
                  .then((response) => {
                    toast.dismiss();
                    toast.success("Preview email sent");
                    //history.push('/pre-construction/my-project');
                    
                  })
                  .catch((error) => {
                   
                  }) 
          });
        }
      };
    render() {
     const { projectData } = this.props;
   
    const landingPageUrl = `https://pages.realtyspacehub.com/${projectData?.preConsProjectGuid}`;
        return (
            <React.Fragment>
                <div className="page-content">
                    <MetaTags>
                        <title>Email Editor | Realty Space</title>
                    </MetaTags>
                    <ToastContainer autoClose={2000} />
                    <Container fluid>
                        {/* Render Breadcrumb */}
                    <div>
                  
                    <span className="float-start mb20">
                        <RsLink className="btn btn-light btn-md" iconClass="bx bx-arrow-back" to={`/pre-construction/campaign/send-email/`+ this.props.match.params.projectId}>
                            Back
                        </RsLink>{" "}
                        <strong style={{marginRight:30, marginLeft:20}}>Web Page Links</strong>  Landing Page : {projectData?.isLandingPagePublished ? ( <><a target="_blank" rel="noreferrer" href={landingPageUrl}> <i className="bx bx-link-external font-size-18"></i></a><CopyText textToCopy={landingPageUrl} /></> ) : (<>Not set</>)}<strong style={{marginLeft:20, marginRight:20}}></strong> Openhouse : <a target="_blank" rel="noreferrer" href={"https://openhouse.realtyspacehub.com/" + projectData?.preConsProjectGuid}><i className="bx bx-link-external font-size-18"></i></a> <CopyText textToCopy={"https://openhouse.realtyspacehub.com/" + projectData?.preConsProjectGuid} />
                        <strong style={{marginLeft:20, marginRight:20}}></strong> Download Price : <a target="_blank" rel="noreferrer" href={"https://brochure.realtyspacehub.com/" + projectData?.preConsProjectGuid}><i className="bx bx-link-external font-size-18"></i></a> <CopyText textToCopy={"https://brochure.realtyspacehub.com/" + projectData?.preConsProjectGuid} />
                        <strong style={{marginLeft:20, marginRight:20}}></strong> Worksheet Inquiry : <a target="_blank" rel="noreferrer" href={"https://worksheetenquiry.realtyspacehub.com/" + projectData?.preConsProjectGuid}><i className="bx bx-link-external font-size-18"></i></a> <CopyText textToCopy={"https://worksheetenquiry.realtyspacehub.com/" + projectData?.preConsProjectGuid} />


                    </span>
                    <span className="float-end">
             {/* <button
                type="button"
                className="btn btn-warning w-md me-2"
                
                onClick={this.saveasdraft}
            >
                                 Save as Draft
                                </button>{" "} */}
                                <button
                                  type="button"
                                  className="btn btn-success w-md me-2"
                                
                                  onClick={this.sendPreview}
                                >
                                  Send Preview Mail
                                </button>{" "}
            <button onClick={this.exportHtml}
              
              className="btn btn-primary w-md me-2"
             
            >
              Save & Continue
            </button>
            </span>
            <div className="clearfix"></div>
                       
                    <LoadUnlayer  ref={this.LoadUnlayerRef} />
                    </div>
                    </Container>
                </div>
            </React.Fragment>
        )
    }



}
projectDraftMailEditor.propTypes = {
    t: PropTypes.any,
    history:PropTypes.object,
    match:PropTypes.object,
    ongetProjectUUIDAction: PropTypes.func,
    emailTemplateTitle:PropTypes.object,
    projectData: PropTypes.object,
    loading: PropTypes.bool,
    onGetDraftTemplate: PropTypes.func,
    templatedata: PropTypes.object

}
const mapStateToProps = ({ Project, Template }) => (
    {
      projectData: Project.projectData,
      templatedata: Template.templatedata,
      loading:Project.loading
  
    })
  const mapDispatchToProps = dispatch => ({
    ongetProjectUUIDAction: (id) => dispatch(getProjectUUIDAction(id)),
    onGetDraftTemplate: (id) => dispatch(getDraftTemplate(id)),
  });
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(projectDraftMailEditor))